var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 189.28 34.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.13,31.49c.27-1.51,1.71-2.78,3.23-2.78.91,0,1.62.44,2,1.11l-.94.6c-.23-.43-.63-.69-1.21-.69-.97,0-1.82.8-1.99,1.75-.16.96.39,1.76,1.36,1.76.58,0,1.08-.27,1.46-.69l.72.6c-.6.68-1.47,1.12-2.39,1.12-1.52,0-2.51-1.26-2.25-2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.68,29.76h-2.29l-.22,1.28h2l-.16.97h-2l-.21,1.2h2.35l-.17.96h-3.44l.94-5.37h3.37l-.16.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.1,32.2l1.04,1.97h-1.27l-.94-1.93h-.36l-.34,1.93h-1.08l.94-5.37h2.14c1.23,0,1.61.87,1.46,1.75-.14.76-.81,1.51-1.59,1.65ZM62.96,29.76h-.95l-.29,1.61h.87c.61,0,.93-.37,1-.8.08-.43-.12-.82-.63-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.37,28.8l-.16.96h-1.48l-.78,4.41h-1.08l.78-4.41h-1.48l.16-.96h4.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.24,34.18l-.21-1.29h-2.01l-.65,1.29h-1.15l2.95-5.37h1.17l1.05,5.37h-1.14ZM70.5,31.95h1.37l-.34-2.04-1.04,2.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.04,34.18l.94-5.37h1.08l-.94,5.37h-1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.41,28.8h1.08l-.94,5.37h-.97l-1.37-3.37-.58,3.37h-1.08l.94-5.37h1.01l1.33,3.31.58-3.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.69,28.8l-.16.96h-1.48l-.78,4.41h-1.08l.78-4.41h-1.48l.16-.96h4.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.83,28.8h1.29l-2.6,2.95-.43,2.42h-1.08l.43-2.44-1.57-2.93h1.29l.97,2.04,1.71-2.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.21,33.64c.07-.37.41-.62.76-.62s.62.26.55.62c-.07.37-.41.63-.77.63s-.6-.27-.54-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.83,28.8h1.13l-2.57,5.37h-.97l-.69-5.37h1.12l.37,3.61,1.61-3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.93,29.76h-2.29l-.22,1.28h2l-.16.97h-2l-.21,1.2h2.35l-.17.96h-3.44l.94-5.37h3.37l-.16.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.35,32.2l1.04,1.97h-1.27l-.94-1.93h-.36l-.34,1.93h-1.08l.94-5.37h2.14c1.23,0,1.61.87,1.46,1.75-.14.76-.81,1.51-1.59,1.65ZM107.21,29.76h-.95l-.29,1.61h.87c.61,0,.93-.37,1-.8.08-.43-.12-.82-.63-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.44,34.18l.94-5.37h1.08l-.94,5.37h-1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.05,29.76h-2.24l-.23,1.29h1.77l-.16.95h-1.78l-.38,2.17h-1.08l.94-5.37h3.32l-.16.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.2,34.18l.94-5.37h1.08l-.94,5.37h-1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.86,29.76h-2.29l-.22,1.28h2l-.16.97h-2l-.21,1.2h2.35l-.17.96h-3.44l.94-5.37h3.37l-.16.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.37,28.8c1.54,0,2.24,1.17,1.96,2.7-.27,1.52-1.37,2.67-2.91,2.67h-2.1l.94-5.37h2.11ZM126.2,29.76h-1.02l-.61,3.45h1.02c.9,0,1.5-.8,1.65-1.72.16-.92-.15-1.74-1.04-1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.77,33.64c.07-.37.41-.62.76-.62s.62.26.55.62c-.07.37-.41.63-.77.63s-.6-.27-.54-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124.82.43c1.34,1.18,2.15,2.82,2.28,4.87h4.54l-3.48,19.61h5.58l3.48-19.61h6.47l.82-4.87h-19.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.79,8.53c.68-4.05-1.17-8.1-6.86-8.1h-28.49l-.85,4.87h6.5l-3.48,19.61h5.58l3.48-19.61h6.39l-3.44,19.61h5.58l1.53-8.6h1.1l4.13,8.6h6.5l-4.73-8.92c3.27-.71,6.43-4.02,7.07-7.46ZM79.14,8.67c-.28,1.63-1.67,3.23-4.12,3.23h-3.52l1.17-6.61h3.66c2.31,0,3.09,1.74,2.81,3.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.36,16.17l2.74-15.74h5.58l-2.67,15.31c-.57,3.09,1.21,4.3,3.2,4.3s4.16-1.21,4.69-4.3l2.7-15.31h5.58l-2.74,15.74c-.99,5.65-6.11,9.17-11.16,9.17s-8.92-3.52-7.92-9.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.23,33.75l1.35-5.05c1.07.39,3.02.39,3.2.39,1.81,0,2.81-1.39,3.09-3.09L147.32.43h5.58l-4.45,25.57c-.82,4.51-3.66,8.35-9.59,8.35-.68,0-2.34-.18-3.62-.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "189.28 .43 188.46 5.29 181.99 5.29 178.51 24.91 172.93 24.91 176.41 5.29 160.64 5.29 159.75 10.34 168.6 10.34 167.75 15.35 158.86 15.35 158.05 20.04 168.49 20.04 167.6 24.91 151.58 24.91 155.88 .43 189.28 .43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.26,17.77h5.58c-.28,1.56,1.07,2.77,2.98,2.77,1.81,0,3.34-.92,3.62-2.52.18-.96-.21-1.85-2.24-2.56l-2.77-.89c-5.12-1.46-5.58-4.76-5.19-7.07.78-4.41,5.12-7.5,9.98-7.5s7.78,2.81,6.96,7.57h-5.58c.25-1.46-.46-2.7-2.38-2.7-1.71,0-3.06,1.17-3.3,2.52-.11.5-.11,1.6,2.03,2.24l2.42.82c3.27,1.07,6.54,2.84,5.72,7.28-.89,5.26-5.86,7.6-10.34,7.6-5.22,0-8.28-3.06-7.5-7.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.4,12.77c-.04.1-.1.18-.17.27l-9.99,11.52c-.3.34-.76.48-1.2.36l-6.02-1.64c-.83-.23-1.14-1.25-.58-1.9l7.13-8.22H6.38c-.33,0-.64-.14-.86-.38L.31,7.16c-.69-.75-.16-1.98.86-1.98h31.67c.35,0,.68.16.9.43l4.67,5.63c.41.49.33,1.13-.03,1.54Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo_white.da9114156fc11654904ad394b322b646.svg";
export { ForwardRef as ReactComponent };